let selectedProducts = [];
const contentInner = document.getElementById('content-inner');

async function fetchProductByVariantId(variantId) {
    const response = await fetch(`/variants/${variantId}.js`);
    const variant = await response.json();
    return variant;
}

function updateBundleMeter() {
    const progress = document.getElementById('bundle-progress');
    const offerText = document.getElementById('bundle-offer');
    const freeShippingText = document.getElementById('free-shipping-text');
    const itemCount = selectedProducts.reduce((sum, product) => sum + product.quantity, 0);
    const previousCount = itemCount - 1; // Count before the current update
    
    // Update items count in header
    document.getElementById('sticky-atc-count').textContent = `Items: ${itemCount}`;

    // Update progress bar and offer text
    if (itemCount >= 3) {
        progress.style.width = '100%';
        offerText.textContent = 'Congratulations, your bundle is ready!';
        freeShippingText.style.display = 'block';
        // Only trigger effects when crossing the threshold of a multiple of 3
        if (itemCount % 3 === 0 && previousCount % 3 !== 0 && window.innerWidth <= 767) {
            celebrateCompletion();
            showBundleContent();
        }
    } else if (itemCount === 2) {
        progress.style.width = '85%';
        offerText.textContent = 'Add your free band!';
        freeShippingText.style.display = 'none';
    } else if (itemCount === 1) {
        progress.style.width = '50%';
        offerText.textContent = 'Add 1 more band and get 1 free!';
        freeShippingText.style.display = 'none';
    } else {
        progress.style.width = '0%';
        offerText.textContent = 'Buy 2 and get 1 free!';
        freeShippingText.style.display = 'none';
    }

    // Update total price and savings after meter update
    calculateTotalPrice();
    calculateSavings();
    updatePriceDisplay();
}

function celebrateCompletion() {
    confetti({
        particleCount: 250,
        spread: 70,
        origin: { x: 0.5, y: 1.1 }, // Slightly below screen bottom
        gravity: 0.8,
        colors: ['#6cacbe', '#ffb078', '#feb078', '#caffd1', '#e1c0ff'],
        zIndex: 1000
    });
}

function calculateSavings() {
    let totalSavings = 0;
    const totalItems = selectedProducts.reduce((sum, product) => sum + product.quantity, 0);
    const freeItems = Math.floor(totalItems / 3);
    
    if (freeItems > 0) {
        // Sort products by price to get the cheapest ones first
        const sortedProducts = [...selectedProducts].sort((a, b) => 
            parseFloat(a.variantPrice) - parseFloat(b.variantPrice)
        );
        
        let remainingFreeItems = freeItems;
        for (const product of sortedProducts) {
            const freeQuantity = Math.min(remainingFreeItems, product.quantity);
            if (freeQuantity > 0) {
                totalSavings += (parseFloat(product.variantPrice) / 100) * freeQuantity;
                remainingFreeItems -= freeQuantity;
            }
            if (remainingFreeItems === 0) break;
        }
    }
    
    document.getElementById('bundle-savings').textContent = `$${totalSavings.toFixed(2)}`;
    return totalSavings * 100; // Return in cents for consistency
}

function updatePriceDisplay() {
    const totalItems = selectedProducts.reduce((sum, product) => sum + product.quantity, 0);
    const freeItems = Math.floor(totalItems / 3);
    
    const sortedProducts = [...selectedProducts].sort((a, b) => 
        parseFloat(a.variantPrice) - parseFloat(b.variantPrice)
    );
    
    selectedProducts.forEach(product => {
        const priceElement = document.querySelector(`#product-${product.variantId} .item-price`);
        if (priceElement) {
            priceElement.textContent = `$${(product.variantPrice / 100).toFixed(2)}`;
            priceElement.style.textDecoration = 'none';
        }
    });
    
    if (freeItems > 0) {
        let remainingFreeItems = freeItems;
        for (const product of sortedProducts) {
            const freeQuantity = Math.min(remainingFreeItems, product.quantity);
            if (freeQuantity > 0) {
                const priceElement = document.querySelector(`#product-${product.variantId} .item-price`);
                if (priceElement) {
                    if (freeQuantity === product.quantity) {
                        // If all quantities are free, show strikethrough and FREE!
                        priceElement.innerHTML = `<s>$${(product.variantPrice / 100).toFixed(2)}</s> <span class="free-text">FREE!</span>`;
                    } else {
                        // If only some quantities are free, show regular price for paid items and FREE! for free items
                        priceElement.innerHTML = `${product.quantity - freeQuantity} × $${(product.variantPrice / 100).toFixed(2)}, <span class="free-text">${freeQuantity} FREE!</span>`;
                    }
                }
                remainingFreeItems -= freeQuantity;
            }
            if (remainingFreeItems === 0) break;
        }
    }
}

function renderProduct(product) {
    const productTitle = product.title;
    const featuredImageUrl = product.imageUrl;
    const quantity = product.quantity;
    const VariantTitle = product.variantTitle;
    const VariantPrice = product.variantPrice;
    
    document.getElementById("noproduct").style.display = 'none';

    const itemHtml = `
        <div class="atc-item" id="product-${product.variantId}">
            <img
                class="atc-item-image"
                width="60px"
                height="60px"
                src="${featuredImageUrl}"
                alt="${productTitle}"
            >
            <div class="atc-item-inner">
                <div class="item-info">
                    <span class="item-title">${productTitle}</span>
                    <span class="item-variant">${VariantTitle}</span>
                </div>
                <div class="bundle-cart-right">
                    <span class="item-price">$${(VariantPrice / 100).toFixed(2)}</span>
                    <div class="bundle-quantifier">
                        <a onclick="handleDecreaseQuantity('${product.variantId}')" class="clear-cart">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <title>minus</title>
                                <path d="M436 284c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h424z"/>
                            </svg>
                        </a>
                        <span class="atc-quantity" id="quantity-${product.variantId}">${quantity}</span>
                        <a onclick="handleIncreaseQuantity('${product.variantId}')" class="clear-cart">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <title>plus</title>
                                <path d="M436 228H252V44c0-6.6-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12v184H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h184v184c0 6.6 5.4 12 12 12h32c6.6 0 12-5.4 12-12V284h184c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12z"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    `;
    contentInner.insertAdjacentHTML('beforeend', itemHtml);
    updateBundleMeter();
}

function updateProductQuantity(variantId, quantity) {
    const quantityElement = document.getElementById(`quantity-${variantId}`);
    if (quantityElement) {
        quantityElement.textContent = quantity;
    }
    updateBundleMeter();
}

function handleDecreaseQuantity(variantId) {
    const productIndex = selectedProducts.findIndex(product => product.variantId === variantId);
    if (productIndex !== -1) {
        selectedProducts[productIndex].quantity -= 1;
        if (selectedProducts[productIndex].quantity <= 0) {
            // Remove the product from the array
            selectedProducts.splice(productIndex, 1);
            // Remove the product element from DOM
            const productElement = document.getElementById(`product-${variantId}`);
            if (productElement) {
                productElement.remove();
                if (selectedProducts.length === 0) {
                    document.getElementById("noproduct").style.display = 'block';
                    const button = document.getElementById('add-bundle-to-cart');
                    button.disabled = true;
                }
            }
        } else {
            updateProductQuantity(variantId, selectedProducts[productIndex].quantity);
        }
        // Update UI after removal
        updateBundleMeter();
    }
}

function handleIncreaseQuantity(variantId) {
    const productIndex = selectedProducts.findIndex(product => product.variantId === variantId);
    if (productIndex !== -1) {
        selectedProducts[productIndex].quantity += 1;
        updateProductQuantity(variantId, selectedProducts[productIndex].quantity);
    }
}

function bundle(myvariant) {
    const selector = document.getElementById(myvariant);
    const option = selector.options[selector.selectedIndex];
    const variantId = selector.value;
    const productIndex = selectedProducts.findIndex(product => product.variantId === variantId);
    
    var title = selector.getAttribute("data-product-title");
    var img = selector.getAttribute("data-product-img");
    var variantTitle = option.getAttribute("data-variant-title");
    var variantPrice = option.getAttribute("data-variant-price");

    const button = document.getElementById('add-bundle-to-cart');
    button.disabled = false;

    if (productIndex !== -1) {
        selectedProducts[productIndex].quantity += 1;
        updateProductQuantity(variantId, selectedProducts[productIndex].quantity);
    } else {
        const newProduct = { 
            variantId, 
            variantTitle, 
            variantPrice, 
            title, 
            imageUrl: img, 
            quantity: 1 
        };
        selectedProducts.push(newProduct);
        renderProduct(newProduct);
    }
    return false;
}

function calculateTotalPrice() {
    let totalPrice = 0;
    let savings = calculateSavings();

    for (const product of selectedProducts) {
        totalPrice += (parseFloat(product.variantPrice) / 100) * product.quantity;
    }

    totalPrice -= savings / 100;

    document.getElementById('sticky-atc-total').textContent = `$${totalPrice.toFixed(2)}`;
}

async function atc_bundle() {
    if(selectedProducts.length > 0) {
        await addToCart(selectedProducts);
        selectedProducts = [];
        contentInner.innerHTML = '<span id="noproduct" style="display: block; text-align: center;">Bundle added to cart!</span>';
        updateBundleMeter();
        const button = document.getElementById('add-bundle-to-cart');
        button.disabled = true;
    }
}

async function addToCart(products) {
    for (const product of products) {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: product.variantId,
                    quantity: product.quantity
                }]
            })
        })
        .then(response => response.json())
        .catch(error => {
            console.error('Error adding to cart:', error);
        });
    }
}

  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.klaviyo-bis-button');
    const popup = document.getElementById('klaviyo-bis-popup');
    const productName = document.getElementById('klaviyo-bis-product-name');
    const variantIdField = document.getElementById('klaviyo-bis-variant-id');
    
    buttons.forEach(button => {
      button.addEventListener('click', function () {
        const name = this.dataset.variantTitle || this.dataset.productTitle;
        const variantId = this.dataset.variantId;
        
        productName.innerText = name;
        variantIdField.value = variantId;
        popup.style.display = 'block';
      });
    });

    document.getElementById('klaviyo-bis-form').addEventListener('submit', function (e) {
      e.preventDefault();

      const email = this.email.value;
      const variantId = this.variant_id.value;

      // Send to Klaviyo via custom event
      _learnq.push(['identify', { '$email': email }]);
      _learnq.push(['track', 'Back In Stock Request', {
        variantId: variantId,
        email: email
      }]);

      this.innerHTML = "<p>Thanks! We'll notify you when it's back.</p>";
    });
  }); 
